import { TRACKING_EVENT_NAMES } from "@/libs/tracking/events";
import { useTrackEvent } from "@/libs/tracking/useTrackEvent";
import { ChevronLeftIcon, NavigationAction, NavigationActionIcon, NavigationActionText } from "@leplein/ui";
import { useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const NavigationHeaderBackAction = () => {
	const { t } = useTranslation("common");
	const router = useRouter();
	const trackEvent = useTrackEvent();

	const handleBackPress = () => {
		trackEvent(TRACKING_EVENT_NAMES.BACK_CLICK, { page: "spots" });
		router.history.back();
	};

	return (
		<NavigationAction onPress={handleBackPress}>
			<NavigationActionIcon as={ChevronLeftIcon} />
			<NavigationActionText>{t("back")}</NavigationActionText>
		</NavigationAction>
	);
};
